var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.168 10.439L14.376.648a2.21 2.21 0 0 0-.717-.479A2.21 2.21 0 0 0 12.814 0a2.21 2.21 0 0 0-1.562.648l-9.785 9.784-.01.01a2.21 2.21 0 0 0-.492 2.361 2.21 2.21 0 0 0 .773.993c.348.249.762.392 1.19.41h.068.39v7.2a2.59 2.59 0 0 0 .755 1.834 2.59 2.59 0 0 0 1.832.761h3.83a.7.7 0 0 0 .7-.7v-5.652a1.18 1.18 0 0 1 1.18-1.18h2.259a1.18 1.18 0 0 1 1.18 1.18v5.652a.7.7 0 0 0 .7.7h3.83a2.59 2.59 0 0 0 2.586-2.586v-7.2h.362a2.21 2.21 0 0 0 2.041-1.363 2.21 2.21 0 0 0-.477-2.408l.006-.005zm-1 2.129a.8.8 0 0 1-.568.235h-1.061a.7.7 0 0 0-.7.7v7.908a1.18 1.18 0 0 1-1.18 1.18h-3.13v-4.942a2.59 2.59 0 0 0-2.586-2.586h-2.259a2.59 2.59 0 0 0-2.586 2.586v4.945H5.971a1.18 1.18 0 0 1-1.18-1.18v-7.907a.7.7 0 0 0-.7-.7H3.008a.8.8 0 0 1-.734-.501.8.8 0 0 1 .181-.869l9.79-9.789a.8.8 0 0 1 .568-.237.8.8 0 0 1 .568.237l9.788 9.787a.8.8 0 0 1 .236.568.8.8 0 0 1-.236.567l-.001-.002z",
    fill: "#00c8d4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.a20c03ba29ba5d16e7b93e773ad9bc13.svg";
export { ForwardRef as ReactComponent };